import { render, staticRenderFns } from "./LimitTransaction2.vue?vue&type=template&id=56c5046c&scoped=true&"
import script from "./LimitTransaction2.vue?vue&type=script&lang=js&"
export * from "./LimitTransaction2.vue?vue&type=script&lang=js&"
import style0 from "./LimitTransaction2.vue?vue&type=style&index=0&id=56c5046c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5046c",
  null
  
)

export default component.exports